import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherFrameStyleId {
  CHEVRON = 'chevron',
  CUBES = 'cubes',
  HEXAGON_WEAVE = 'hexagon_weave',
  OCTAGONS = 'octagons',
  DAMASK = 'damask',
}

export class GiftVoucherFrameStyle extends Codebook<GiftVoucherFrameStyleId> {
  static readonly CHEVRON = new GiftVoucherFrameStyle(GiftVoucherFrameStyleId.CHEVRON, () =>
    $t('Chevron'),
  )
  static readonly CUBES = new GiftVoucherFrameStyle(GiftVoucherFrameStyleId.CUBES, () =>
    $t('Cubes'),
  )
  static readonly HEXAGON_WEAVE = new GiftVoucherFrameStyle(
    GiftVoucherFrameStyleId.HEXAGON_WEAVE,
    () => $t('Hexagon weave'),
  )
  static readonly OCTAGONS = new GiftVoucherFrameStyle(GiftVoucherFrameStyleId.OCTAGONS, () =>
    $t('Octagons'),
  )
  static readonly DAMASK = new GiftVoucherFrameStyle(GiftVoucherFrameStyleId.DAMASK, () =>
    $t('Damask'),
  )

  private constructor(
    public readonly value: GiftVoucherFrameStyleId,
    public readonly label: () => string,
  ) {
    super(value)
  }
}
